export function setConnSignalR(status) {
  return {
    type: 'SET_CONN_SIGNALR',
    payload: status,
  }
}
